import Header from "@components/layout/Header";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import { colors } from "@styles/colors";
import { useNavigate } from "react-router-dom";
import { YStack, Text, XStack, Card, View } from "tamagui";
import { RiArrowLeftSLine } from "react-icons/ri";
import TextCustom, { TextSize } from "@components/TextCoustom";
import TransactionHistory from "./components/wallet/TransactionHistory";

export const TransAll = () => {
  const navigate = useNavigate();
  const prevPathname = "/account/wallet";
  const price = 1310;
  return (
    <YStack height="100dvh" width="100vw" background={colors.bg}>
      <Header>
        <XStack alignItems="center" onPress={() => navigate(prevPathname)}>
          <View mr="$2">
            <RiArrowLeftSLine size={20} color={colors.light} />
          </View>
          <TextCustom str="交易紀錄" type={TextSize.SMALL} color={colors.light} bold={true} />
        </XStack>
        <XStack gap="$3" ai="center" jc="center" f={1} m="$3">
          <Card backgroundColor="rgba(16,185,129,0.22)" borderColor="rgba(16,185,129,0.3)" borderWidth={1} borderRadius={16} padding={16} width="50%">
            <YStack>
              <Text color={colors.light} fontSize={14}>
                本月收入
              </Text>
              <Text color={colors.light} fontSize={14}>
                NT$
                <Text fontSize={18} color={colors.light} fontWeight="bold">
                  1,234
                </Text>
              </Text>
            </YStack>
          </Card>
          <Card
            backgroundColor="rgba(251,113,133,0.18)"
            borderColor="rgba(251,113,133,0.3)"
            borderWidth={1}
            borderRadius={10}
            padding={16}
            width="50%">
            <YStack>
              <Text color={colors.light} fontSize={14}>
                本月支出
              </Text>
              <Text color={colors.light} fontSize={14}>
                NT$
                <Text fontSize={18} color={colors.light} fontWeight="bold">
                  1,234
                </Text>
              </Text>
            </YStack>
          </Card>
        </XStack>
      </Header>
      <RadiusContentWrapper>
        <YStack gap="$2">
          <YStack>
            <Text fontWeight="bold">04/20</Text>
            <TransactionHistory headerShow={false} />
          </YStack>
          <YStack>
            <Text fontWeight="bold">04/21</Text>
            <TransactionHistory headerShow={false} />
          </YStack>
        </YStack>
      </RadiusContentWrapper>
    </YStack>
  );
};

export default TransAll;
